
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/contexts/language";
import { t } from "@/utils/translations";
import { PhotoUploadDialog } from "./dialogs/PhotoUploadDialog";

interface UploadPregnancyPhotoDialogProps {
  userId?: string;
  onPhotoUploaded: () => void;
  week?: string;
}

export function UploadPregnancyPhotoDialog({ 
  userId, 
  onPhotoUploaded,
  week
}: UploadPregnancyPhotoDialogProps) {
  const { language } = useLanguage();
  
  // Get the week number from the week string
  const weekNumber = week?.match(/\d+/)?.[0] || "";
  const weekCategory = weekNumber ? `pregnancy-week-${weekNumber}` : "pregnancy";

  return (
    <PhotoUploadDialog
      userId={userId}
      onPhotoUploaded={onPhotoUploaded}
      initialCategory={weekCategory}
      title={t('gallery.pregnancyPhotoUpload', language)}
      trigger={
        <Button variant="outline" size="sm">
          {t('gallery.uploadPhoto', language)}
        </Button>
      }
    />
  );
}
